import axios from 'axios';

import {
  ResponseObj,
  ConsultaPostFormData,
  ConsultaPutFormData,
  ConsultaAlterarQueixasCondutasPrivadaFormData,
} from '../../../back/src/types';
import { Consulta } from '../../../back/src/entity/Consulta';

const criaConsulta = async (
  formData: ConsultaPostFormData,
): Promise<ResponseObj<Consulta>> => {
  const res = await axios.post<ResponseObj<Consulta>>('consultas', formData);
  return res.data;
};

const alteraConsulta = async (
  formData: ConsultaPutFormData,
): Promise<ResponseObj<Consulta>> => {
  const res = await axios.put<ResponseObj<Consulta>>('consultas', formData);
  return res.data;
};

const cancelaConsulta = async (
  formData: ConsultaPutFormData,
): Promise<ResponseObj<Consulta>> => {
  const res = await axios.put<ResponseObj<Consulta>>('consultas/cancelar', formData);
  return res.data;
};

const finalizaConsulta = async (
  formData: ConsultaPutFormData,
): Promise<ResponseObj<Consulta>> => {
  const res = await axios.put<ResponseObj<Consulta>>('consultas/finalizar', formData);
  return res.data;
};

const consulta = async (consultaId: number): Promise<ResponseObj<Consulta>> => {
  const res = await axios.get<ResponseObj<Consulta>>(`consultas/${consultaId}`);
  return res.data;
};

const consultaQueixasCondutas = async (consultaId: number): Promise<ResponseObj<string|null>> => {
  const res = await axios.get<ResponseObj<string|null>>(`consultas/${consultaId}/queixas_condutas`);
  return res.data;
};

const consultaAlterarQueixasCondutasPrivada = async (
  consultaId: number, formData: ConsultaAlterarQueixasCondutasPrivadaFormData,
): Promise<ResponseObj<Consulta|null>> => {
  const res = await axios.put<ResponseObj<Consulta|null>>(`consultas/${consultaId}/queixas_condutas_privada`, formData);
  return res.data;
};


export default {
  criaConsulta,
  alteraConsulta,
  cancelaConsulta,
  finalizaConsulta,
  consulta,
  consultaQueixasCondutas,
  consultaAlterarQueixasCondutasPrivada,
};
